import { render, staticRenderFns } from "./VoucherBox.vue?vue&type=template&id=707eabbe&scoped=true&"
import script from "./VoucherBox.vue?vue&type=script&lang=js&"
export * from "./VoucherBox.vue?vue&type=script&lang=js&"
import style0 from "./VoucherBox.vue?vue&type=style&index=0&id=707eabbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707eabbe",
  null
  
)

export default component.exports